import {
  BlockAsProp,
  BlockType,
  FCNavWidgetBlock,
  FooterWidgetBlockType,
  NavWidgetBlockType,
} from "@kameleon-core/types";
import React, { ReactElement } from "react";
import { Box } from "theme-ui";

type WidgetType = NavWidgetBlockType<{}> | FooterWidgetBlockType<{}>;

/** FooterWidgetBlock section */
function widgetBlock<T extends WidgetType>(
  widgetType: BlockType.FooterWidget | BlockType.NavWidget,
  RenderComponent: (props: T) => ReactElement
): FCNavWidgetBlock<T> {
  const block: FCNavWidgetBlock<T> = (props: T): ReactElement => {
    const Component = RenderComponent(props);
    const classPrefix =
      widgetType === BlockType.FooterWidget ? "footer" : "nav";
    return <Box className={`${classPrefix}__widget-block`}>{Component}</Box>;
  };
  block.blockType = widgetType;
  return block;
}

const renderWidgetBlock = <T extends WidgetType>(
  blockProp?: BlockAsProp<T>
): null | ReactElement => {
  if (!blockProp || !blockProp.block) return null;
  return (
    <Box className="widget-block">
      {React.createElement(
        blockProp.block,
        blockProp.props as any,
        blockProp.children
      )}
    </Box>
  );
};

export { widgetBlock, renderWidgetBlock };
